import lazySizes from 'lazysizes'
import 'lazysizes/plugins/respimg/ls.respimg'

// Image Lazy-loading
lazySizes.cfg.lazyClass = 'Image -lazy'
lazySizes.cfg.preloadClass = 'Image -preloaded'
lazySizes.cfg.loadingClass = 'Image -loading'
lazySizes.cfg.loadedClass = 'Image -loaded'
